import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import { GRADIENT_COLOR, COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT, PACKAGE_HEIGHT_EXTRA } from '@src/styles/config';

const StyledPackageCustomItem = styled(Card)`
  .buy-extra-characters-button {
    height: 40px;
    margin-bottom: 16px;
    text-transform: none;
    color: ${COLOR.darkBlue};
    font-size: 14px;
    font-weight: 700;
    border-color: #3c3c4329;
    border-radius: 8px;
  }
  .free-amount-credits {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-out-line-icon {
      font-size: 14px;
      color: #1e164ea3;
    }
  }
  .text-amount-credits-pkg {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .buy-extra-chars-pack-vip-button {
    background: linear-gradient(
      93.26deg,
      #ffffff -11.27%,
      #4987ff 46.65%,
      #e064e3 94.64%
    );
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 1);
    transition: 0.7;
    &:hover {
      opacity: 0.7;
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .extra-characters {
    position: relative;
  }
  .discount-tag {
    width: 38px;
    position: absolute;
    top: -6px;
    right: -42px;
  }
  .box-range {
    margin-top: 32px;
  }
  .flexItem {
    display: flex;
    justify-content: space-between;
  }

  .tooltip {
    color: ${COLOR.tooltipColor};
    svg {
      width: 16px;
      height: 16px;
    }
  }
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(props) => props.chosenPackage && '#FFFCEC'};
  border: ${(props) =>
    props.isPoppular ? '3px solid #ffd60a' : '3px solid transparent'};
  box-shadow: none;
  overflow: visible;
  padding: 21px 13px 5px 13px;
  border-radius: 16px;
  .package-feature-row {
    display: none;
  }
  .package-feature-column {
    display: initial;
  }

  .container-header-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /* .container-info-header-option {
    display: none;
  } */
  ${({ isRow }) =>
    isRow &&
    `
    padding: 24px 40px;
    .card {
      flex-direction: row;
      gap: 40px;
      align-items: center;
    }
    .container-custom-resources {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: 16px;
      border-radius: 12px;
      padding: 16px;
      background: ${COLOR.charcoal};
      .block-resource {
        width: 100%;
        .container-info-option {
          display: none;
        }
      }
      .block-resource:nth-child(1) {
        width: 100%;
        .container-header-option {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .container-info-header-option {
            display: flex !important;
            align-items: center;
          }
        }
      }

      .block-resource:nth-child(2),
      .block-resource:nth-child(3) {
        width: calc((100% - 16px) / 2);
        .container-info-option {
          align-items: center;
          display: flex;
        }
        .container-info-header-option {
          display: none;
        }
      }
    }
    .package-feature-row {
      display: flex;
      flex-direction: column;
    }
    .package-feature-column {
      display: none;
    }
    .group-package-header {
      display: flex;
      flex-direction: column;
      row-gap: 4px;
    }
    .container-package-header {
      display: flex;
      flex-direction: column;
      width: 288px;
      gap: 24px;

      .package-name {
        font-size: 32px;
        font-weight: bold;
        color: ${COLOR.darkGray};
      }
    }
    .container-package-price {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      align-self: center;
      width: 286px;
      .card-content {
        width: 100%;
      }
      .unit-price {
        font-size: 20px;
        font-weight: 700;
      }
      .three-first {
        font-size: 40px;
        font-weight: 800;
      }
      .price {
        font-size: 40px;
        font-weight: 800;
      }
      .three-last {
        font-size: 20px;
        font-weight: 700;
      }
      .original-price-not-line-through {
        font-size: 16px;
      }
      .price-wrapper .original-price-not-line-through {
        font-size: 20px;
      }
      .original-custom-price-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .price-original-discount {
        padding-top: 2px;
        .discount-unit-price {
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: ${COLOR.lightText};
          text-transform: lowercase;
          padding-bottom: -2px;
        }
        .original-price-month {
          font-size: 16px;
          white-space: nowrap;
          text-decoration: line-through;
          color: ${COLOR.lightText};
        }
      }
    }
    .container-resource {
      display: flex;
      flex-direction: column;
      flex: 3;
    }
    .container-package-price-and-option {
      display: flex;
      flex-direction: row-reverse;
      flex: 5;
      gap: 40px;
    }
  `}
  .package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    max-height: 60px;
    .MuiTypography-root {
      line-height: 1;
    }
  }

  .package-icon {
    border-radius: 9999px;
    background-color: ${COLOR.black[8]};
    width: 48px;
    height: 48px;
  }

  .package-icon-active {
    border-radius: 9999px;
    background-color: ${COLOR.primary};
    width: 48px;
    height: 48px;
  }

  .card-content {
    margin-top: ${(props) => props.isMobile && '8px'};
    position: relative;
  }

  .card-info {
    text-align: center;
  }

  .disabled-icon-content {
    color: ${COLOR.light} !important;
  }

  .icon-content {
    color: ${COLOR.primary};
  }

  .most-popular {
    background: ${GRADIENT_COLOR.orange};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .popularity {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: 24px;
    background: ${COLOR.yellow[16]};
    padding: 2px;
    padding-left: 12px;
    border-radius: ${(props) => (props.isMobile ? '8px' : '0px 0px 12px 12px')};

    .popularity-text {
      font-size: 12px;
    }
  }

  .crown-icon {
    margin-right: 4px;
  }
  .name-content {
    display: flex;
    align-items: center;
    gap: 0 4px 0 0;
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkGray};
  }

  .package-name-vip {
    background: linear-gradient(95.62deg, #4987ff 1.99%, #e064e3 23.11%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .package-name-popular {
    font-size: 20px;
    font-weight: bold;
    color: #ff5a12;
  }

  .price-package-vip {
    background: linear-gradient(
      96.23deg,
      #ffffff -35.11%,
      #4987ff 35.41%,
      #e064e3 168.05%
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
    background-position: center;
  }

  .package-limited-deal {
    font-size: 12px;
    font-weight: 500;
    color: ${COLOR.darkBlue};
    background: ${COLOR.yellow[64]};
    padding: 2px 8px;
    border-radius: 20px;
    width: fit-content;
  }

  .chip-wrapper {
    display: flex;
    top: 0;
    left: 0;
    gap: 8px;
  }

  .price-package {
    display: flex;
    align-items: center;
    letter-spacing: -1.4px;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: ${(props) => (props.isMobile ? '0px' : '24px')};
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }
  .original-custom-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
    gap: 6px;
  }

  .price-original-discount {
    padding-top: 2px;
    .discount-unit-price {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.lightText};
      text-transform: lowercase;
      padding-bottom: -2px;
    }
  }

  .original-price,
  .original-price-not-line-through {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-not-line-through {
    text-decoration: none;
    margin-left: -6px;
  }

  .price-en {
  }

  .original-card {
    min-height: 52px;
  }

  .price {
    font-size: 24px;
    letter-spacing: 0;
    font-weight: 700;
    white-space: nowrap;
    color: ${COLOR.darkBlue};
    display: flex;
    align-items: center;
  }

  .price-highlight {
    font-size: 24px;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: 0;
    color: #ff5a12;
    display: flex;
    align-items: center;
  }

  .three-first {
    font-size: 32px;
    font-weight: 800;
  }

  .three-last {
    font-size: 16px;
    font-weight: 700;
  }

  .unit-price {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR.darkBlue};
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .unit-price-highlight {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: '#FF5A12';
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .unit-price-vip {
    .unit-price {
      font-weight: 510;
      font-size: 16px;
      line-height: 15px;
      color: ${COLOR.darkBlue};
      text-transform: lowercase;
      padding-bottom: -2px;
      background: linear-gradient(
        96.23deg,
        #ffffff -35.11%,
        #4987ff 35.41%,
        #e064e3 168.05%
      );
      background-clip: text;
      -webkit-text-fill-color: transparent;
      text-decoration: none;
      position: relative;
    }
    .unit-price::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(
        96.23deg,
        #ffffff -35.11%,
        #4987ff 35.41%,
        #e064e3 168.05%
      );
      background: ${(props) => !props?.isVietNam && 'none'};
      border-radius: 2px;
    }
  }

  .per-month {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
  }

  .sub-price {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin-left: 6px;
    color: ${COLOR.black[64]};
  }

  .original-price {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-month {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: line-through;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 12px;
    font-weight: 700;
    color: ${COLOR.lightText};
  }

  .font-size-14 {
    font-size: 14px !important;
  }

  .font-size-16 {
    font-size: 16px !important;
  }

  .underlined {
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
    margin-left: 4px;
  }

  .description {
  }

  .chip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.darkBlue};
    color: ${COLOR.primary};
    border-radius: 6px 0px;
    padding: 0px 6px;
    height: ${PACKAGE_HEIGHT_EXTRA}px;
  }

  .chip-none {
    height: ${PACKAGE_HEIGHT_EXTRA}px;
    padding: 0px 6px;
  }

  .text-chip {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin: auto;
  }

  .button-start {
    font-weight: bold;
    margin-top: ${(props) => (props.sliderCreditsFeatures ? '81px' : '24px')};
    border-radius: ${(props) =>
      props.highlight && props.isPoppular ? '12px 12px 0px 0px' : '12px'};
    opacity: ${(props) => (props.isDisableButton ? '0.5' : '1')};
    border-color: ${COLOR.darkBlue};
    color: ${COLOR.darkBlue};
    text-transform: none;
    height: 40px;
    padding: 8px 16px;
    box-sizing: border-box;
    pointer-events: ${(props) => props.isDisableButton && 'none'};
  }

  .button-package-vip {
    border: 1px solid rgba(102, 154, 255, 1);
  }

  .button-highlight {
    background: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    border-color: ${COLOR.primary};
  }

  .free-package-button {
    height: 78px;
  }

  .text-limited {
    margin: 6px 0px 3px 0px;
    color: ${COLOR.lightText};
  }

  .icon-contents {
    margin-left: -16px;
    margin-right: 5px;
    .dots {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 5px;
      margin-bottom: 1px;
    }
  }
  .title-text {
    color: #1c1c1e;
    font-weight: 700;
    margin-top: 14px;
    margin-bottom: 16px;
    font-size: 14px;
  }
  .clarify {
    margin-bottom: 8px;
    opacity: 1 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    padding-right: 0;
    .coming-soon-text {
      width: 100% !important;
    }
    .coming-soon-text-advanced {
      color: #5856d6 !important;
      font-weight: 700;
    }
    .coming-soon-title {
      color: #1c1c1ea3;
      font-size: 14px;
      margin-left: 5px;
      font-weight: 400;
    }
    .item-package {
      width: 100%;
      display: flex;
      word-wrap: break-word;
      align-items: center;
      .content {
        color: #1c1c1e;
      }
    }
  }
  .package-content-item {
    margin-bottom: 8px;
  }

  .tooltip {
    display: flex;
    align-items: center;
  }
  .note {
    font-style: italic;
    font-size: 14px;
    color: #1c1c1ea3;
  }
  .disabled-content {
    color: ${COLOR.red};
  }

  .content {
    color: #1c1c1ea3;
    strong {
      color: ${COLOR.darkGray};
    }
    font-size: 14px;
    p {
      margin: 0;
    }
  }

  .content-deactivate {
    color: ${COLOR.light};
    font-size: 14px;
  }

  .btn-view-more-container {
    display: flex;
    justify-content: center;

    padding: 5px;
  }

  .show-more-btn {
    padding: 0px !important;
    margin: 10px 26px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    background-color: transparent;
    color: ${COLOR.indigo[100]};
    text-decoration: underline;
    text-transform: none;
    min-width: 0px !important;
  }

  .new-show-more-btn {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    color: rgba(30, 22, 78, 0.64);
    text-transform: none;
    background: none;
  }
  .description-package {
    color: #1c1c1ea3;
    font-weight: 400;
    font-size: 14px;
    height: 42px;
    letter-spacing: -0.4;
  }
  .voucher-gift-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLOR.yellow.default};
    border-radius: 8px;
    height: 28px;
    width: 28px;
    box-sizing: border-box;
    padding: 8px;

    img {
      width: 16px;
      height: 16px;
    }

    .gift-icon {
      width: 10px;
      height: 10px;
      color: ${COLOR.indigo.default};
    }

    .voucher-name {
      font-size: 10px;
      font-weight: 500;
      margin-left: 5px;
      line-height: 14px;
      letter-spacing: -0.4px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    overflow: ${(props) => (props.mostpopular ? 'hidden' : 'visible')};

    .chip-none {
      height: 0px;
    }

    .card-info {
      margin-top: 0px !important;
    }
  }
`;

export { StyledPackageCustomItem };
